import chexfinerfoodsLogo from "/img/integration/chexfinerfoods.png"
import { ConnectEmailPage } from "../connect-email-page"

export function ConnectChexFinerFoodsPage() {
  return (
    <ConnectEmailPage
      logo={chexfinerfoodsLogo}
      logoAlt="Chex Finer Foods"
      integrationName="chexfinerfoods"
      description="Chex Finer Foods sends deduction and dispute information via email. Connect the email account(s) that receive Chex Finer Foods communications."
      redirectTo="/setup/config/chexfinerfoods"
    />
  )
}
